import type { ResolutionLadder, Tier } from "./types";

/**
 * Pick the finest tier whose bucket is coarse enough to hit ~targetPointsPerPx
 * across the chart and is not finer than the series' native cadence.
 */
export function tierForViewport(
  spanMs: number,
  widthPx: number,
  ladder: ResolutionLadder,
  opts: { targetPointsPerPx: number; nativeMs: number }
): Tier {
  if (ladder.length === 0) throw new Error("tierForViewport: resolution ladder is empty");
  const sorted = [...ladder].sort((a, b) => a.bucketMs - b.bucketMs); // fine → coarse
  const targetBucketMs = spanMs / Math.max(1, widthPx * opts.targetPointsPerPx);
  const floorMs = Math.max(opts.nativeMs, targetBucketMs);
  return sorted.find((t) => t.bucketMs >= floorMs) ?? sorted[sorted.length - 1];
}
